module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BU-BIG ParaOverride-1",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vimeo.com/88771195",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("See VIDEO")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('a', {
    attrs: {
      "id": "p16"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/havanna_karte_ohne_Schriftzug_tina.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("trip to Cuba feels like a trip into the past. Because of the U.S. trade embargo, the range of products available is extremely limited, so in many regions ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("you may feel like you’ve landed in the 1950s. Nevertheless, ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("there’s been a transformation over the past few years and we think the country’s going to be changing rapidly. Large Western corporations are slowly penetrating the Cuban market, embargo or not. So our advice to you is: If you’re thinking of visiting Cub")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("…")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("do it NOW!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The island itself is a fairy-tale Caribbean paradise: crystal-clear water, snow-white sandy beaches, coconut palms—the whole package. But that wasn’t what we were there for. Right from the start, we found something in Havana that interested us much more than the usual tourist fare—we joined up with a clique of Cuban skaters, surfers, and tattoo and graffiti artists. Life with this crowd was so exciting and varied that we made the executive decision to spend our entire Cuba trip in Havana. Instead of spending a month traveling around the country as we’d originally planned, we stayed the entire two months in Havana—interrupted only by a five-day excursion to Varadero, but that can be summed up in just a few words: palm trees, white beach, cheap mojitos, and tons of tourists.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Join us on our visit to Havana and go see the rest of Cuba firsthand on your next vacation.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p18.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-16",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("HAVANA")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("A")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("t the Frankfurt airport, we spent our last euros on greasy bratwurst and German pilsner in plastic cups. That this was not our most brilliant move became clear when, after an eleven-hour flight, we finally landed at the Havana airport and found ourselves planted in front of the only ATM, which had a display reading “out of order.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Barely arrived and already stranded. How would we get to ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("the city? Nothing to do but hang out in the airport parking")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" lot with a sheepish look and hope for a small miracle. We waited next to a line of ancient cars that would normally be seen only in gangster movies. But fate was looking out for us after all: After no more than five minutes, we were approached by Ka, a Hawaiian photographer. He, too, had just landed in Havana, and asked us if we wanted to share a cab into the city. We described our desperate financial position, and he offered to give us a lift. So we hailed one of the gangster cabs and took off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story _idGenParaOverride-1",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("In the center of Havana, we came up against our next obstacle: finding a place to sleep. In Cuba, it’s common for tourists to stay in ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("casas particulares")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", which are small rooms or mini apartments rented out by private citizens at prices regulated by the government. There’s one on practically every street corner, and a night’s lodging costs something between 14 and 28 euros. On the off chance ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("that there might be a place for us, we rode with Ka to the")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("casa")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" he’d reserved in advance and hit the jackpot—the last available bunk bed for 4.50 euros each.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_6.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-4"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("e spent the entire next day not withdrawing")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cash. All the ATMs conspired against us and our credit cards. But we didn’t give up the search; we kept asking around and were sent from one place to another until we’d covered half the city. Still no go. With Ka’s last $3, we ordered mojitos and Cuban cigars in a small bar. Why not? Helpless and frustrated, we chewed on our cigars and slowly worked our way through our drinks, staring out the door into the street, wondering where we’d be spending the night. Suddenly, Cozy’s jaw dropped. He stared in disbelief as Michael Mackrodt, a German pro skater and Cozy’s friend, walked in the door. Michael was as surprised to see us as we were to see him. He had a small skate and film crew in tow and was producing a new skate video. What a coincidence!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story _idGenParaOverride-1",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Everything went unbelievably smoothly after that. The guys had already found out where there were working ATMs, and they opened other doors for us, too. Within the next few days, we met Miles Jackson of Cuba Skate and, through one twisted connection after another, Havana’s entire skate, surf, tattoo, and graffiti community. The clique called itself 23yG after the intersection nearest their favorite street skate spots. They were there every day, of course, so there was no need to schedule a meeting. Day and night we skated with the 23yG gang through Havana—through the streets by day, through the bars by night. Incidentally, here’s a tip in case you run into financial trouble: The best places to get cash in Havana are the large luxury hotels, such as the Habana Libre. They usually have a ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("casa de cambios")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" where you can withdraw money with just a MasterCard and your passport. If you’re on a tight budget, exchange your CUCs (Cuban Convertible Pesos) for ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("moneda nacional")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", the parallel currency, and use the locals’ infrastructure. You’ll be able to ride from one end of the city to the other for just a few cents instead of a few dollars.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('a', {
    attrs: {
      "id": "p21"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p21.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-3"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("fter skate sessions with 23yG, we often went to eat at an out-of-the-way courtyard restaurant, Mama Patio. To get there you have to pass through a maze of alleyways, dog kennels, and fire escape ladders until you finally reach a small balcony with palm trees belonging to a warm and friendly woman with the best soul food in Havana. You’ll find Mama Patio in the Vedado quarter on Avenida 23 between Calles C and D. Our favorite dish was ropa vieja, or “old cloths,” a traditional Cuban beef dish. According to tradition, this recipe has to be passed down from generation to generation. We got it from our friend and future chef Rafa, who got it from his grandmother. Check it out.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-17",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/slow_food_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("ROPA VIEJA ")]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL ParaOverride-2",
    attrs: {
      "id": "_idParaDest-18",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("PULLED BEEF WITH RICE AND BLACK BEANS")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "italicB"
  }, [_vm._v("Ropa vieja")]), _vm._v(" is served with rice or, to be exact: "), _c('span', {
    staticClass: "italicB"
  }, [_vm._v("moros y cristianos")]), _vm._v(". More about that on the next page. You could also serve this with deep-fried plantains.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("SERVES 4")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer066"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung-Head",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("Marinade")]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 cups (1 l) malt beer")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons onion powder ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons garlic powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("6 tablespoons Worcestershire sauce ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" pounds (1 kg) beef chuck roast")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("8 cups (2 l) vegetable stock")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung-Head",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("Ropa VIEJA")]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Olive oil, for browning")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 scallions, thinly sliced ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 red bell pepper, seeded and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 green bell pepper, seeded and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 (")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("-ounce/70 g) can tomato paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" cup (100 g) pitted green olives")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 (1-pound/450 g) can chopped tomatoes, with liquid")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Several sprigs parsley, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor006"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Moros y Cristianos")])]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", for serving")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer067"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To prepare the beef, mix together the beer, onion powder, garlic powder, oregano, cumin, bay leaves, Worcestershire sauce, and pepper in a large bowl, and marinate the beef in this mixture for 30 minutes. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heat the stock to a simmer in a large pot and add the beef along with the marinade. Simmer the beef in the stock, covered, for at least 3 hours. If you want, you can simmer it for 4 to 5 hours; then it’ll be even more tender and easier to shred!")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Transfer the beef from the pot to a large bowl. Shred it finely using two forks. It’s easy to do and it’ll start your mouth watering.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heat the olive oil in a large pot over medium heat and sauté the scallions, bell peppers, and tomato paste for 3 to 4 minutes. Cut the olives into rings and add the olives and chopped tomatoes to the vegetables, stirring the mixture for several minutes until it’s uniformly mixed. Add the shredded beef and season with salt and pepper to taste. Remove the pot from the heat and stir in the chopped parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Serve with")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" moros y cristianos")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("—bon appétit!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1ba"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('a', {
    attrs: {
      "id": "p22"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer070"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-19",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/slow_food_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("MOROS Y CRISTIANOS")]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL ParaOverride-2",
    attrs: {
      "id": "_idParaDest-20",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("black beans and rice")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer071"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cuban cuisine almost always includes ")]), _c('span', {
    staticClass: "italicB",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("congris")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" or ")]), _c('span', {
    staticClass: "italicB",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("moros y cristianos")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" (“Moors and Christians”), a mixture of black beans and rice. This dish—in different versions called by different names—is a popular side dish throughout Latin America.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer072"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("SERVES 4")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer073"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (200 g) black beans, soaked for at least 12 hours in lots of water")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5 tablespoons olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 small yellow onion, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("12 slices (50 g) bacon, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" green bell pepper, seeded and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 ml) white wine")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (200 g) rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer074"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Rinse and drain the beans and place in a pot along with the bay leaves and lots of fresh water and bring to a boil. Simmer for about 1 hour, or until tender. Drain the beans, reserving the cooking water, and discard the bay leaves. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heat the olive oil in a skillet over low heat and sauté the onion, garlic, bacon, and bell pepper. This mixture is called a sofrito. Add the white wine to the sofrito, then add ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _vm._v("⅔"), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (400 ml) of the reserved bean-cooking water, along with the beans themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Add the rice, cumin, and oregano to the sofrito- ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("bean mixture. Simmer over low heat until the rice has absorbed the water and is fully cooked, about 30 to 35 minutes. Then simply season it with salt and pepper, and it’s ready!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1ba"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer075"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer076"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer079"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-5"
  }, [_vm._v("Y")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("ojani and Frank, two 23yG crew members who were ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("the same age as us, invited us to stay at Frank’s ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mother’s house. His mother, Isa, is an architect and artist who doesn’t think much of the Communist regime. Her house is a regular shelter for surfers and skaters from around the world. Frank rides a BMX, Yojani a skateboard. Both are also unbelievably good surfers. In 2008, Frank was even invited by the International Olympic Committee to represent Cuba in the Pan American Surfing Games in Brazil, but was unable to go due to the Communist government’s strict travel policies. He still hasn’t gotten over it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Because they’re so persecuted, skaters and surfers in Cuba are a close-knit community. They all know and help each other because they all share the same problems. There’s no place to buy equipment in Cuba. There isn’t a single skate or surf shop in all of Cuba, and there aren’t even skate shoes. Some skaters who seemed especially desperate even tried to talk us out of our old, worn-out sneakers. The only way these guys can get new equipment is if somebody actually brings it from another country and leaves it with them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Such scarcity makes people inventive, and it’s impressive to see how creative these guys are when it comes to compensating. Just take an old metal chair leg, some gaffer’s tape, a soldering iron, and a tripod head and you’ve got an instant hand rig for filming skate videos. Frank simply saws the front third off a surfboard, shortens the board by about 8 inches (20 centimeters), and glues it back together. He now has a 6-foot 1-inch shortboard. What’s even more amazing is that with this do-it-yourself apparatus he still manages to do aerials off the waves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("If left to ourselves, we probably would never have known that there was surfing in Havana—not if Frank hadn’t shown us photos of perfect tubes in the middle of Havana, in the Vedado quarter just off Calle 10.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer080"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer081"
    }
  }, [_c('p', {
    staticClass: "BU-BIG",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("YOJANI DONATES HIS WHEELS TO THE NEXT GENERATION.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-6"
  }, [_vm._v("F")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("rom a culinary point of view, Cuba is at first glance a disappointment. Very few products are available to the average person. In most shops the shelves are almost completely empty or are filled with the same few items—rice, beans, potatoes, and cassava roots. Almost everything that’s imported is too expensive for the Cuban population to buy. A jar of olives costs around 4 CUCs (or $4), which is the equivalent of 100 Cuban pesos, the parallel currency used by the Cubans. By way of comparison: The average salary paid by the government is around 30 CUCs per month. Cubans buy most of their food with ration cards. Staples such as rice, meat, salt, and sugar are rationed, but there’s also a number of small ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("street stands where a piece of greasy flatbread with a little ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("tomato sauce and cheese substitute is sold as a pizza for about 50 cents.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("But if you wander the streets a little, you can find fine little bistros that serve local Cuban cuisine at ridiculously low prices. Most of the dishes consist of a piece of pork with the typical Cuban side of ")]), _c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor006"
    }
  }, [_c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("moros y cristianos")])]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", a mixture of rice and black beans. These often come with deep-fried plantains and a small salad. It’s all topped with ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("aliño criollo")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", a homemade sour vinegar sauce with little chunks of chopped onion, garlic, pepper leaves, and small, mild green chile peppers floating in it, served in a battered plastic bottle. On the street this meal comes in a little cardboard box and is then called ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cajita")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", as in our Cajita de Cerdo that follows.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer082"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_15.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-21",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/low_budget_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("CAJITA DE CERDO")]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL ParaOverride-2",
    attrs: {
      "id": "_idParaDest-22",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("pork in a box")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Literal translation: pork in a cardboard box. Here’s our own version. If you want, you can get some hamburger boxes and serve it in classic street-food fashion.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" pounds (1 kg) pork shoulder or pork belly")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 tablespoons olive oil, plus more for frying ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 stalks celery, coarsely chopped ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 carrot, peeled and coarsely chopped ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 yellow onion, coarsely chopped ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("8 to 10 sprigs parsley, chopped ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 shots dark rum")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 bunch cilantro, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung2",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor006"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Moros y Cristianos")])]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung2",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (240 ml) vegetable oil, plus more for the salad ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 plantain, peeled and sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 green bell pepper, seeded and chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tomato, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cucumber, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung2",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor023"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Aliño Criollo")])]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", for serving")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Preheat the oven to 425°F (220°C). Rub the meat with the olive oil, oregano, and cumin. Distribute the celery, carrot, onion and parsley in a deep baking pan or a Dutch oven. Pour on the rum, season with salt and pepper, and place the pork on top. Cook the pork in the oven for 1½ hours, basting it every 20 minutes with the meat juices that form.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Remove the pork from the oven and wrap it in aluminum foil. Pour the rest of the baking dish contents through a strainer and reserve the meat juices, but discard the rest. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Add the cilantro to the ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("moros y cristianos")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(". Then add the meat juices and stir until the rice and beans form a creamy mixture. Cover with foil to keep warm. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heat the vegetable oil in a saucepan and deep-fry the plantain slices for about 2 minutes. Then remove them from the pan and drain them on a plate lined with paper towels. Season with salt to taste. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("In a large bowl, toss together the bell pepper, tomato, and cucumber to make a salad. Dress the salad with just a little vegetable oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Distribute the rice-bean mixture among four plates. Cut the pork into large cubes, season it with salt and pepper, and distribute it over the four mounds of rice and beans. Arrange the plantain slices next to the pork. Top with a shot of ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("aliño criollo")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" and enjoy!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-23",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("hidden markets")]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("fter spending a few days scouring the city on foot, we gradually began to discover hidden corners. Havana was constantly surprising us: At a triangular courtyard market behind the Capitol on Dragones Street, we found an 11-year-old, chain-smoking boy who sold spices from a wooden rack. He had peppercorns, bay leaves, turmeric, cinnamon, paprika, cloves, oregano, cumin, soup spice, and nutmeg—an excellent supply of basic spices for our trip. Eventually we even found an amazingly well-stocked market in our own neighborhood (Playa, Calle 42). Although the mangoes, papayas, pineapples, limes, and lettuce were expensive, at least they were available. In addition to all sorts of fruits and vegetables, they even sold bunches of mint, cilantro, and parsley—our favorite herbs. Loaded up with as many ingredients as we could possibly carry, we made our way home to Isa, already composing in our heads the menu for the family’s evening meal: spicy chicken quarters with homemade Caribbean rum salsa, mango salad, deep-fried salted plantains, and lime rice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p31.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1ba"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p32.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-24",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/low_budget_Text_11.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("COSITA BUENA")])]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL ParaOverride-2",
    attrs: {
      "id": "_idParaDest-25",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("mango chicken legs")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This isn’t really a typical Cuban dish. It has strong Jamaican influences, and contains a pinch of the desperation we felt as we searched for unusual and original recipes. So what—it’s delicious!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("serves 2")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung-Head",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("chicken")]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon sweet paprika")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon curry powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (60 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 chicken leg quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung-Head",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("mango salad")]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 mangoes, peeled and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 scallion, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 bunch cilantro, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Freshly squeezed juice of 2 limes")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons coconut oil, melted")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon chili powder or 1 red chile pepper, seeded and minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung-Head",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("lime rice")]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (200 g) rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (300 ml) water")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 kaffir lime leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung2 ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor021"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Rum Ketchup")])]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(", for serving")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Preheat the oven to 390°C (200°C).")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To make the chicken, peel the garlic, squeeze it through a press, and combine it with the paprika, curry powder, olive oil, salt, and pepper. Rub this marinade into the chicken leg quarters, place them in a casserole dish, and bake them for about 45 minutes. While they’re baking, prepare the side dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To make the mango salad, in a large bowl toss together the mango chunks, scallion, and cilantro. Combine the lime juice, coconut oil, chili powder, salt, and pepper to make a dressing. Just before serving, pour the dressing over the mangoes and scallions and toss the salad. ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To make the rice, combine the rice, salt, water, and kaffir lime leaves in a pot and bring it to a boil over medium heat. Lower the heat and cook the rice for 20 minutes, or until it has absorbed all the water and is soft. If it’s still a little grainy, add a little more water and cook it for another 5 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Arrange the chicken, mango salad, and lime rice on two plates and serve with the ketchup.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer098"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_20_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer099"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_20_3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer102"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_21.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer103"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-26",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("the roof of HAVANA")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer105"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-8",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("D")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("uring one of our many explorations of Havana, we suddenly found ourselves in front of a fairly tall building in poor condition (the building, not us). The view from that roof had to be fantastic. Shrugging, we walked right in. After a skeptical examination of the rickety elevator, we decided to take the narrow stairs. Four floors later, we were facing the heavy iron door to the roof. There was a little doorbell on the wall, so we pushed it and waited. A large brown eye peered at us through a crack, and then an enormous woman opened the door, giving us a suspicious look and at the same time smiling broadly. She invited us into her realm—the building’s flat roof. Actually she, her husband, their 5-year-old daughter, and an overexcited black puppy all lived in a tiny garret in just one corner of the roof—we estimated it to be no more than 107 square feet (10 square meters)—containing two beds, a minimalist kitchen, and a sort of bathroom area. It opened our eyes to another world. The obligatory television set showed dancing Latinas flickering in analog quality. Soup was bubbling on the stove, spreading its seductive fragrance over the entire roof. She let us have a taste. The climb was definitely worth it!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer108"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-27",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/low_budget_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("SOPA DE  LENTEJAS ")]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL",
    attrs: {
      "id": "_idParaDest-29",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("rooftop lentil soup")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer107"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1em"
    },
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer109"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("6 cups (1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" l) vegetable stock")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (200 g) red lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 cups (250 g) diced carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (250 g) diced cassava root (or substitute potatoes)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (250 g) diced yellow summer squash")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 red chile pepper, seeded and minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 star anise")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (420 ml) coconut milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon curry powder ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground turmeric ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cinnamon ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of brown sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 2 limes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Several sprigs cilantro, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung ParaOverride-3",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Several sprigs mint, minced")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Heat the vegetable stock in a large pot and add the lentils, carrots, cassava, squash, chile pepper, garlic, bay leaves, star anise, and coconut milk. Stir everything together thoroughly, cover the pot, and simmer over low heat for 20 minutes. Continue to stir occasionally so it won’t burn to the bottom of the pot.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept ParaOverride-4",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Add the curry powder, turmeric, cumin, and cinnamon. Let the soup stand for another 5 minutes. Add the brown sugar and lime juice, and season with salt and pepper to taste. Sprinkle the cilantro and mint over the top, and it’s done—dig in!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer111"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer112"
    }
  }, [_c('p', {
    staticClass: "BU-BIG",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("they may not have much, but there’s one thing that no one can take away from them. Every evening they have the finest view of havana’s magical sunset.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer113"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer115"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_26.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer117"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-9",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("C")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("uba has skaters and lots of surfers, even beyond ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("the 23yG crew. The guys and girls who practice")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" this exotic sport reminded us a little of defiant Gauls forced to stand up against the superior power of the ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Romans. The police are constantly confiscating their ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("boards, and every once in a while, someone spends a night")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" in jail because they took the twelve steps of a marble Communist monument with a frontside flip instead of walking down on their feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The rest of the population also looks on these sports with suspicion. Skaters and surfers are seen as good-for-nothing bums and troublemakers. Once when we were surfing off the Malecon, the police called us back to shore. Stupidly, we’d left Cozy alone on the seawall with all the camera equipment and backpacks, filming, while the rest of us surfed. A policeman was now standing next to him, gesticulating wildly and blowing his whistle. Frank and Yojani paddled 1¼ miles (2 kilometers) to the other shore and escaped—in these sorts of confrontations, the police often end up confiscating their boards and throwing them in jail. Swimming at the Malecon is strictly forbidden!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To lend Cozy support, I reluctantly paddled in and climbed up the slippery seawall. As tourists, our friends ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("explained, they couldn’t do much to us because tourists")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" in Cuba are untouchable. First came a long discussion with the uniformed guard. All our efforts to explain were wasted. Swimming is prohibited. Sit down. We sat on the seawall beside a nervous cop under a blazing-hot midday sun for two solid hours. The policeman clutched his radio, every five minutes calling for backup that never came. Finally at one point, a truck carrying more policemen on its bed stopped in front of us. One of the policemen jumped down and spoke briefly with our surf-police guard, who then climbed onto the truck and disappeared with the rest of them. So now we waited in the heat of a Cuban afternoon with another uniformed clown. He obviously had no idea why he was guarding us, but he did his best. Another hour passed before the long-awaited squad car finally came. Out climbed the chief, who gave the order: Load everything into the car and take ’em down to the station!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("By now we were starting to get worried. We had absolutely no desire to get caught up in Cuban police bureaucracy. Obediently, we loaded all the backpacks into the trunk of the squad car, wondering what was in store for us when we finally reached the station. But then came an impossible dilemma: The surfboards wouldn’t fit into the squad car. Three policemen stood around the car, frowning and thinking. While they heatedly discussed the situation, we laughed to ourselves. Finally, they came up with an extremely simple and surprising solution: Take everything out again! Go home! Don’t do it again! Uh—OK, bye, see you tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("What was for us just a close shave happens to skaters and surfers in Cuba all the time, but without the protection of being tourists. If we’d been Cuban they would, at the very least, have taken our boards and thrown us in jail. Such experiences are painful, but they also serve to bring the local board-sports community even closer together. Skaters and surfers help each other out. If someone ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("breaks their board, two people share. The older members")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teach their tricks to the younger, and they repair anything that breaks by pooling their knowledge and improvisational skills. If anyone gets new equipment, they give ")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("their old gear away. It’s like one big family. Some members")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" of the crew are currently working on opening Cuba’s first surf bar and restaurant. They already have the first item for their menu—the Cubano Sandwich, which you’ll find on the next page.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer119"
    }
  }, [_c('p', {
    staticClass: "BU-BIG",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Frank executing a skillful violation of the swimming ban at the Malecon.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer121"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-33",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/slow_food_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("CUBAN SANDWICH")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer122"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("We hope you’re not religious, because this hefty sandwich is a sin. A genuine Cuban street-food classic. It’s not exactly good for you, but it tastes SUPREME. Our suggestion: Follow this sandwich with partial penance in the form of a swim workout.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer123"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("makes 8 Sandwiches")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer124"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" pounds (1 kg) pork shoulder or pork roast with the skin (or cold leftover pork roast!)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 medium white onion, peeled")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoons ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("8 large panini rolls or other Italian or French bread rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor022"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mayonnaise")])])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 pound (500 g) cooked ham, sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("32 pickle slices")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("16 slices Swiss cheese ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 tablespoons (50 g) butter, melted")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer125"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Place the pork, peeled onion, and bay leaves in a large pot filled with water. Bring the water to a boil, and simmer the pork for 3 hours. Make sure the pork is always completely covered with liquid.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Preheat the oven to 400°F (200°C).")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Remove the pork from the water and pat it thoroughly dry. Finely grind the cumin, sugar, and salt and pepper to taste in a mortar and pestle and rub this mixture into the pork shoulder. Place the pork on a baking sheet and bake it for 15 minutes. The prolonged boiling makes the pork as soft as butter on the inside, while rapid baking in the oven gives it a nice crust on the outside. Baking also caramelizes the sugar on the skin, giving the pork a sweet, smoky note. Normally this sandwich calls for pulled pork, which would mean smoking the meat in a smoker for at least 18 hours. Our version is much quicker!")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cut the rolls in half lengthwise. Spread the bottom halves with mustard and the top halves with mayonnaise. Take the pork out of the oven and shred it using two forks. Season it once again with salt and pepper and mix it with a little of the meat juices from the baking sheet.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Distribute the pork on the 8 bottom rolls and cover it with the ham. Top each sandwich with 4 pickle slices and 2 cheese slices, and then replace the roll tops. Spread a little melted butter on top of each sandwich and toast them in a sandwich toaster, panini press or a stovetop griddle or pan for 1 to 2 minutes—and the famous Cuban sandwich is ready to eat.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('a', {
    attrs: {
      "id": "p42"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_29.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer128"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p44.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer131"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-34",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1fl",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "alt": "",
      "src": "image/icon_welle_blau_84_0_18_0.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("cuba SURF GUIDE")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer129"
    }
  }, [_c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("We had Yojani and Frank write the surf guide for Cuba, because if anyone knows where to find waves in Cuba, it’s those two!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cuba has waves only in the winter when the huge Atlantic swells pass between the Bahamas upstream. It isn’t constant, but when the swells do come, you’ll find excellent waves in several spots.")])]), _vm._v(" "), _c('p', {
    staticClass: "absatzüberschrift",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("P")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("LAYA SETENTA ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("23.11175°N -82.44205°E")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Our favorite spot in Havana has bathtub-warm Caribbean waves breaking over a reef. Under perfect conditions, you’ll have glassy barrels. You’ll find the wave in the Playa district where 70th Street ends at the water, directly in front of the Hotel Neptuno-Tritón.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("There’s a left peak and a right peak. ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Comegofios")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" (a slang term for anyone from the Canary Islands) generally stay to the left and regulars to the right. This spot makes a brutal first impression because the entrance crosses a sharp-edged reef. But with a depth of around 4 feet (1.2 meters), you’ll have enough water under you to feel safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "absatzüberschrift",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("E")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("L CAYO")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v(" 23.09891°N -82.45471°E")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This spot is in the Playa district on Avenida 3a at the level of Calle 112, just before La Isla del Coco amusement park. One of the island’s best waves breaks here, with rides up to 18 seconds long. There are lefts and rights and the water isn’t too shallow. Good for beginners!")])]), _vm._v(" "), _c('p', {
    staticClass: "absatzüberschrift",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("L")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A SOCIEDAD ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("23.09365°N -82.48455°E")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Here there are rights and lefts about 131 feet (40 meters) out at the Playa Jaimanitas fishing beach. The right is less dangerous because it’s less shallow than the left, but the left has barrel sections.")])]), _vm._v(" "), _c('p', {
    staticClass: "absatzüberschrift",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("E")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("L BAJO (MALECON) ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("23.13839°N -82.40707°E")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("As the name implies, this spot is at the Malecon—or more specifically, where the Río Almendares empties into the ocean on the east side of the estuary at the level of Calle 10. As is usual near a river mouth, the water is sometimes pretty filthy. But note: Sometimes you get harassed by the police because swimming is officially prohibited at the Malecon. This is Frank Gonzales’s favorite spot, but it takes nerves and experience to surf here. Sharp rocks are lurking everywhere and the water is only about as deep as a hot tub. But if you want to surf the best tubes of your life, you’ll have to come here—it has the best tubes in all of Cuba.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer133"
    }
  }, [_c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Yojani also has a tip about an awesome spot on the eastern side of the island. Unfortunately, we never had a chance to surf there ourselves:")])]), _vm._v(" "), _c('p', {
    staticClass: "absatzüberschrift",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("B")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("OCA DE YUMURI ")]), _c('span', {
    staticClass: "zutaten-zusatz CharOverride-11"
  }, [_vm._v("20.51370°N -74.65098°E")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This spot is on the northeast side of Cuba, 15 minutes south of the village of Baracoa. It’s a paradise with 656- to 985-foot-wide (200 to 300 meter) tubes at a river mouth above a rocky sea floor. Depending on the swells, it’s good both to the right and to the left of the river. Just next door is a tiny indigenous fishing village where the people eat only what they catch or grow themselves. If you go there, ask for Roberto, a friendly surfer who likes to show off his home waves and the special sights of this Caribbean paradise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("In short: If you’re a surfer and visitor to Cuba, you must surf Setenta and Yumuri, otherwise all you’ve done is tour another island.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer132"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_32.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer134"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer135"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_33_6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer139"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-35",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_vm._v("Graffiti in cuba")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer137"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-10"
  }, [_vm._v("M")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("arcos explained to us that the few graffiti artists who live here make their own paints by mixing pigments from printer cartridges with gasoline. Although they can buy bad cans of cheap auto paint and fill them with their own mixture, one can costs the equivalent of about $4.50 (4 euros). Nobody here can afford that many cans, so they have to use brushes for blending their colors. They generally paint dilapidated buildings left over from the Soviets, or they might ask permission from the owner of a wall they particularly like. Most people here won’t say no to free wall painting.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer140"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p46.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer141"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_35.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer142"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-36",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/veggie_Text_1.png"
    }
  }), _c('a', {
    attrs: {
      "id": "basic"
    }
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("basic ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("provisions")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "_idContainer144"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-8",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("magine you’re sitting on the beach after a strenuous surf session, you’ve just roasted a juicy, crusty piece of meat on a stick over a fire, and now you have to eat it without a glob of the world’s best barbecue sauce. Oh, the horror!")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Or just as bad: You’re on a road trip and you wind up in a small fishing village where an old man is selling fresh lobsters out of the trunk of his car, but you don’t have any homemade chipotle-lime sauce on you. The very thought brings tears to your eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Flie-text-Story",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("To avoid such disaster, we generally travel with a couple of canning jars and are constantly preparing a fresh supply of sauces, salsas, and chutneys for the days to come. A splotch of ")]), _c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor030"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Caribbean Pesto")])]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" turns a toasted roll into a holiday treat, and some homemade ")]), _c('a', {
    attrs: {
      "href": "#/04_CUBA_mobi#_idTextAnchor027"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Plum, Coconut, and Lemongrass Marmalade")])]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" in the morning consoles you against the fact that the only shop for miles around carries nothing but moldy instant coffee. At night after a bottle of rum, you’ll be beside yourself with joy when you can dip cold grilled meat left over from dinner into a sweet-and-spicy yellow bell pepper sauce. Don’t miss out on these moments. Be prepared and learn by heart our recipes for basic provisions on the next few pages.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer152"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-39",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v("RUM KETCHUP")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer153"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "zutaten-zusatz CharOverride-14"
  }, [_vm._v("makes 4 cups (1 Liter)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer149"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 small white onions")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" 5 cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" 2 tomatoe")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" 5 tablespoons olive oi")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" ounces (50 ml) dark rum")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (60 ml) vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (400 g) strained chopped tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 2 limes")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cinnamon stick")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5 tablespoons light brown sugar ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of salt")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer146"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peel and mince the onions and garlic. Remove the seeds from the tomatoes and dice them finely. Heat the olive oil in a saucepan over low heat and cook the onions and garlic until translucent. Then add the chopped tomatoes and cook for another 3 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Add the rum and carefully light it on fire. A simple trick: Light a dry piece of spaghetti—then you won’t burn your fingers! Stir the sauce well while the alcohol is burning off so that it all mixes together nicely.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("As soon as the flame dies out, add the vinegar. After 1 minute, add the strained tomatoes, lime juice, cinnamon stick, bay leaves, and cumin. Stir well, and simmer the ketchup for 30 minutes over low heat, stirring occasionally.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("When the ketchup is thick enough and has acquired a nice aroma, add the sugar and salt, tasting as you add the sugar in increments. You’re the best judge of how salty or sweet you want your ketchup to be. That’s all there is to it! Pour it into a sterilized bottle and stand it upside-down for 5 minutes. Refrigerated, the ketchup will keep for about 2 weeks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer155b"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/p50.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer147"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-38",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("SALSA VERDE")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer148"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This sauce is awesome with fish and meat, or even potatoes. It’s much healthier than ketchup and the fresh herbs give it a nice, refreshing flavor. When we make it, half the sauce usually ends up going straight from the blender into our mouths.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer154"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("MAKES about ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups")]), _c('br'), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(ABOUT 600 Ml) ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer150"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 large bunch cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 large bunch parsley, leaves only")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 large bunch mint, leaves only")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (240 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 heaping teaspoon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons capers (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 anchovy fillets (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt (optional)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer151"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Place the cilantro, parsley, and mint in a blender along with ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("½")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup of the olive oil. Add the mustard, capers, anchovy fillets, and lemon juice. If you use capers and anchovies the sauce will automatically be salty enough. If you leave out these ingredients you’ll need to add some salt.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Start up the blender and blend into a thick paste. You’ll have to adjust the amount of oil depending on the size of your herb bunches. Gradually add more oil until you have a runny herb mixture, occasionally switching on the blender for short bursts. Pour the salsa into a clean jar. Refrigerated, the salsa will keep for about 1 week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer155"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_37_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer156"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-40",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("CHIPOTLE-LIME SAUCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer158"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Few things in this world taste better dipped in a hot-and-sour mayonnaise than breaded and baked or deep-fried shrimp. The combination will blow you away. This dip always turns out perfectly if you make it with store-bought mayonnaise, but if you’re especially industrious, you can of course make your own mayo.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer159"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-15",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("For those who prefer the simple surf-trip version with store-bought mayo:")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer157"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 5 ounces (ABOUT 150 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer161"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 tablespoons mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 lime")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 dashes Tabasco or other hot sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 heaping teaspoon cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon turbinado sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Freshly ground black pepper")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer160"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Just mix everything together thoroughly and it’s done! Transfer the sauce to a clean jar. Refrigerated, the sauce will keep for about 10 days.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "_idContainer163"
    }
  }, [_c('a', {
    attrs: {
      "id": "mayo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-15",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("for those who like to do it themselves: here’s our basic mayo recipe!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer165"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 11 ounces (about 330 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer164"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 large egg yolks, preferably organic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 ml) peanut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("–")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (180–240 ml) sunflower oil")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer162"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Place the egg yolks in a large bowl. Add the salt and sugar and beat the yolks with a wire whisk to thicken them slightly. Then add a few drops of peanut oil—no more than ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("½")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoon—and whisk vigorously and thoroughly until the oil and egg yolks become a homogenous mixture. Add a few more drops of oil. Be very careful not to add too many drops at a time or your mayo won’t thicken properly. Mayo is finicky—sometimes it doesn’t matter what you do, you just can’t keep it from separating! After about 3 teaspoons of oil, the mayo should slowly start to thicken. Then you can add the oil in a thin stream. But never stop whisking!")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("When you’ve used up all the peanut oil, continue with the sunflower oil. You may not use all the sunflower oil. If your mayo thickens sooner, leave out the remainder.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Refrigerated in an airtight container, the mayonnaise will keep for 8 to 10 days, but it’s safer to use it up immediately.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer166"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_38.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer168"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-41",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("ALIÑO CRIOLLO  ")]), _c('br'), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Creole Salsa")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer169"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This hot-and-sour sauce is part of Cuban cuisine. It goes especially well with pork but also makes a nice dressing for a side salad. In Cuba, this extraordinary sauce is usually found in battered ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("plastic bottles on the tables of streetside restaurants. It keeps for a long time and is easy to make.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer170"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Makes 14 ounces (ABOUT 400 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer171"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 small green chile peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Several cilantro stems")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (240 ml) apple cider vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5 tablespoons extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 2 limes")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 star anise")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoon ground cumin ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer172"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Remove the seeds from the chile peppers and cut the peppers into thin rings. Chop the cilantro. Peel and crush the garlic. Place all of the ingredients in a clean bottle and shake well. Refrigerated, the sauce will keep for several weeks. The longer it stands, the spicier and hotter it becomes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer167"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_39_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer174"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-42",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("NICA SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "Headline-SMALL",
    attrs: {
      "id": "_idParaDest-43",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Nicaraguan salsa ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer177"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This sauce is at its best when you sear chicken and add a generous shot to the pan. It’s also excellent with the ")]), _c('span', {
    attrs: {
      "href": "#/05_MEXICO_mobi#_idTextAnchor080",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Grilled Vegetable Teriyaki Salad")])]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(". Or you can use it as a marinade for grilled meat or to brown chicken—this sauce does it all!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer176"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 17 ounces (ABOUT 500 ml)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer173"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 clove garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" inches (6 cm) fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon coconut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 ml) dark rum ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 ml) soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4 tablespoons honey")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 lime")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon turbinado sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoon ground cinnamon")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer178"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peel the garlic and ginger and grate both finely. Melt the coconut oil in a small saucepan over low heat and soften the garlic and ginger in the oil for about 3 minutes. At the very end, turn the heat up to high and carefully add the rum.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("After the rum has cooked off (takes about 3 to 6 minutes) add the soy sauce, honey, lime juice, sugar, cayenne, and cinnamon to the saucepan, along with 3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("½")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" tablespoons (50 ml) water. Decrease the heat and simmer the sauce for another 5 minutes. Pour the sauce into a glass bottle and stand it upside down for 5 minutes. Refrigerated, the sauce will keep for about 2 weeks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer175"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_39_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer181"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-44",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("cilantro SAlsa ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer182"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("MAKES 21 ounces  (ABOUT 600 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer183"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup (240 ml) soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (120 ml) sunflower oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" inches (4 cm) fresh ginger, finely grated ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 bunch cilantro, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 2 limes, or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Salt (optional)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer180"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pour the soy sauce into a blender and switch it on to the lowest setting. With the blender running, gradually add the olive oil and then the sunflower oil in a thin stream until the oils are emulsified.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("With the blender still running, add the ginger, cilantro, and sugar. Then add the lime juice and salt at the very end—preferably not all at once. You might like your salsa less sour than we do. Pour the salsa into a clean jar. Refrigerated, it will keep for about 1 week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer179"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_40_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer185"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-45",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("MANGO CHUTNEY ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer184"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 16 ounces ")]), _c('br'), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(ABOUT 450 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer187"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 mangoes (not too ripe or soft)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 small red onion")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 red chile pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon honey")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("(")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("8")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" l) white wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 2 limes, or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon ground cinnamon, or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoon ground cumin, or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 kaffir lime leaves")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer188"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peel and dice the mangoes. Peel the onion and cut it into eighths. Peel the garlic and squeeze it through a press. Remove the seeds from the chile pepper and chop the pepper finely.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("In a small saucepan, heat the olive oil over medium heat and cook the onions until they’re soft, translucent, and slightly brown and sizzled around the edges, about 10 minutes. Add the diced mango, garlic, chile pepper, honey, and vinegar. Lower the heat and simmer this mixture for about 15 minutes, stirring regularly to keep it from sticking to the pan.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Season the chutney to taste with the lime juice, cumin, and cinnamon, and add the kaffir lime leaves. While it’s still hot, transfer the chutney to a glass jar and stand the jar upside down for 5 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Let the chutney cool, and refrigerate it for at least a few hours before serving. Then you’ll see how its structure has changed. The chutney develops a fantastic sweet-and-sour flavor. In a sterilized jar, this will keep for at least 4 months. If you didn’t sterilize the jar, it will keep for about 2 weeks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer186"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_40_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer191"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-46",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("Plum, coconut, and lemongrass MARMaLADE ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer192"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 16 ounces (ABOUT 450 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer194"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cardamom pod")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 whole clove")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 cups (300 g) diced plums")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 lemongrass stems, tender interior only")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 tablespoons grated fresh coconut")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 orange")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" tablespoons (70 g) pectin")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 tablespoon stevia powder (35 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer193"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Remove the seeds from the cardamom pod and grind the cardamom seeds and clove in a mortar and pestle. Place all of the ingredients in a pot, stir well, and bring to a boil.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Simmer the marmalade for 10 minutes. While it’s still hot, transfer the marmalade to a glass jar and stand the jar upside down for 5 minutes. If you sterilized the jar, the marmalade will keep for several months or even a year or so. If you didn’t sterilize the jar, it will keep for 2 weeks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer189"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_41_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer195"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer196"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-47",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("PERSIMMON, GINGER, GRAPEFRUIT, and CHILe MARMALADE")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer198"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("makes 16 ounces (ABOUT 450 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer199"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 allspice berry ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" pound (300 g) persimmon, diced ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 inches (5 cm) fresh ginger, grated ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" red chile pepper, seeded and minced")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2 inches grated peel from lime")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 lime ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of ")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" grapefruit")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" ounces (100 g) gelling sugar with stevia")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer200"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Grind the allspice berry finely in a mortar and pestle. Place all the ingredients in a pot, stir well, and bring to a boil. Simmer the marmalade for 10 minutes. While it’s still hot, transfer the marmalade to a sterilized canning jar and stand the jar upside-down for 5 minutes. If everything’s well sterilized, the marmalade keeps for months or even years.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer197"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_41_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer202"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-48",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("POMELO-AVOCADO DIP ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer201"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("MAKES 21 ounces (ABOUT 600 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer204"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" pomelo, peeled and sectioned")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 green bell pepper, seeded and chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 avocado, pitted and peeled")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 scallion, green part only")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup fresh cilantro leaves ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 cup fresh parsley leaves ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("6 tablespoons (89 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Freshly ground black pepper")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer205"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Combine all of the ingredients in a blender on medium speed and—it’s ready to eat! Refrigerated in an airtight container, the dip will keep for up to 1 week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer203"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_42_1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer207"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-49",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("caribbean PESTO ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer208"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("MAKES 21 ounces (ABOUT 600 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer209"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (80 g) mixed nuts (such as walnuts, cashews, brazil nuts, almonds, peanuts)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" ounces (80 g) soft aged goat cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 bunch cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("25 fresh basil leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 tablespoons grated fresh coconut ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 green chile pepper ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (180 ml) coconut milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Juice of 1 lime")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer210"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Combine all of the ingredients (yes, the whole chile with the seeds!) in a blender on medium speed—and you’re done! Refrigerated in an airtight container, this will keep for up to 1 week. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer206"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/Kuba_42_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer214"
    }
  }, [_c('p', {
    staticClass: "Headline",
    attrs: {
      "id": "_idParaDest-50",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("breakfast GRANOLA")]), _c('img', {
    staticClass: "_idGenObjectAttribute-1f",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "image/fast_food_Text_1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer215"
    }
  }, [_c('p', {
    staticClass: "vorspann",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("We never take a surf trip without this perfect—nonperishable, healthy, delicious—instant breakfast. Combined with a little yogurt or milk and fresh fruit, it’s a perfect start to any day. You can vary the nuts, seeds, and dried fruits depending on what’s available locally. This recipe comes from our friend Claudio, a surfing chef from Chile.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer216"
    }
  }, [_c('p', {
    staticClass: "vego-personen",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Makes ABOUT 4 cups (600 g)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer217"
    }
  }, [_c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cups (200 g) old-fashioned oats")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (100 g) trail mix (remove and set aside the raisins, as they shouldn’t be baked)")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (50 g) flaxseeds")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (30 g) white sesame seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" tablespoons (50 g) honey")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" cup (50 g) light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("⁄")]), _c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" teaspoon ground cinnamon ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("1 whole clove")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pinch of fleur de sel")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("3 dried figs, minced ")])]), _vm._v(" "), _c('p', {
    staticClass: "Zutatenaufz-hlung",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Milk or yogurt, and fruits of your choice, for serving")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer218"
    }
  }, [_c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Preheat the oven to 300°F (150°C). In a large baking dish, mix together the oats, trail mix, flaxseeds, sesame seeds, honey, brown sugar, cinnamon, clove, and salt. Bake for 20 minutes, stirring occasionally so that the mixture toasts evenly. Your granola should come out lightly browned and acquire a heavenly fragrance.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Stir in the dried figs and reserved raisins. Serve the granola with a little milk or yogurt and fresh fruit.")])]), _vm._v(" "), _c('p', {
    staticClass: "flie-text-rezept",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sealed in a zipper-top freezer bag, granola easily keeps for several weeks, but you’ll probably eat it all in a couple of days.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer211"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_43.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1b"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer219"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Kuba_44.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer221"
    }
  }, [_c('p', {
    staticClass: "flie-text-Story-initial",
    attrs: {
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('span', {
    staticClass: "_idGenDropcap-11"
  }, [_vm._v("A")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("fter almost two months in Havana, it was time to move on. We were able to experience Havana from a perspective that would normally be totally inaccessible, far from the “Buena Vista Social Club” style of romanticism that we’re programmed to think of as authentic Cuban life. Together with our friends, we visited hidden black markets, we painted graffiti on dilapidated Russian military buildings using homemade gasoline-based paint, we drank home-distilled courtyard rum, and we threw wild house parties. We hated to go. As a parting gift, the 23yG tattoo artist Tere did us the special honor of tattooing us with the 23yG logo. We’ll be back!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b96ddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_CUBA_mobi.vue
// module id = 63
// module chunks = 0